import {  Form, FC, useMemo } from 'external/react'

import usePackage from 'context/package-context/hook'

import FormTextfield from 'components/FormTextfield'

type AddUserFormProps =  {
    role: 'Student' | 'Tutor'
    errors: any    
}

const AddUserForm: FC<AddUserFormProps> = props => {

    const {role, errors} = props
    const {update, state: {modals}} = usePackage()
    const modal = useMemo(() => modals[`add${role}`], [modals, role])

	function createFieldProps (placeholder, fieldName, maxLength?) {
		return {
			placeholder,
			maxLength,
			fieldName,
			value: modal[fieldName],
			submitted: errors.submitted,
			error: errors[fieldName],
			onChange: (e) => {
				update({modals: {[`add${role}`]: {[fieldName]: {$set: e.target.value.trim()}}}})
			}
		}
	}

    return (
        <Form>
                <FormTextfield {...createFieldProps('Nombre', 'first_name', 25)} />
                <FormTextfield {...createFieldProps('Apellido', 'last_name', 25)} />
                <FormTextfield {...createFieldProps('Correo', 'email')} />
                <FormTextfield {...createFieldProps('Télefono', 'phone')} />
        </Form>
    )
}

export {AddUserForm as default}